import React from "react";
import newsEventsImage from "../assets/news_events1.jpg"; // Ensure the correct image path

const NewsEvents = () => {
    return (
        <div className="w-full bg-gray-900 text-white">
            {/* News & Events Section */}
            <div id="news-events" className="bg-gray-900 text-white p-12 sm:p-20 text-center">
  <h2 className="text-4xl sm:text-5xl font-bold mb-6">News & Events</h2>
  <p className="text-lg sm:text-xl leading-relaxed text-justify">
    Stay updated with the latest advancements, events, and industry insights from Proalgenix. 
    Explore our latest news, upcoming conferences, and research innovations in the field of microalgae technology.
  </p>

  {/* Large News & Events Image */}
  <div className="flex justify-center my-12">
    <img 
      src={newsEventsImage} 
      alt="News and Events" 
      className="w-full max-w-4xl object-cover rounded-lg shadow-lg"
    />
  </div>
</div>


            {/* Latest Updates Section */}
            <section className="py-12 sm:py-20 px-6 bg-gray-800">
                <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8">Latest Updates</h2>
                
                <div className="max-w-5xl mx-auto space-y-8">
                    {/* News Item 1 */}
                    <div className="bg-gray-700 p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 duration-300">
                        <h3 className="text-2xl font-semibold text-yellow-400">Proalgenix at Global BioTech Summit 2025</h3>
                        <p className="text-lg mt-2 text-justify">
                            We are excited to participate in the Global BioTech Summit 2025, showcasing our innovations in microalgae-based sustainable solutions.
                        </p>
                        <a href="/news/global-biotech-summit" className="text-blue-400 mt-3 inline-block hover:underline">
                            Read more →
                        </a>
                    </div>

                    {/* News Item 2 */}
                    <div className="bg-gray-700 p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 duration-300">
                        <h3 className="text-2xl font-semibold text-yellow-400">New Research Breakthrough in Algal Biofuels</h3>
                        <p className="text-lg mt-2 text-justify">
                            Our research team has made significant progress in optimizing algae for biofuel production, reducing carbon emissions effectively.
                        </p>
                        <a href="/news/algal-biofuels-breakthrough" className="text-blue-400 mt-3 inline-block hover:underline">
                            Read more →
                        </a>
                    </div>

                    {/* News Item 3 */}
                    <div className="bg-gray-700 p-6 rounded-lg shadow-lg transition-transform transform hover:scale-105 duration-300">
                        <h3 className="text-2xl font-semibold text-yellow-400">Upcoming Webinar: Future of Microalgae in Industry</h3>
                        <p className="text-lg mt-2 text-justify">
                            Join us for an insightful webinar on the growing role of microalgae in pharmaceuticals, nutrition, and sustainable industry practices.
                        </p>
                        <a href="/events/microalgae-webinar" className="text-blue-400 mt-3 inline-block hover:underline">
                            Register now →
                        </a>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default NewsEvents;
